export default "__VITE_ASSET__BTin9MkC__"